import { Box, Checkbox, FormControl, FormGroup, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AppColors } from "resources/AppColors";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
    fontSize: "0.7rem",
  },
}));

const CheckboxWithTooltip = ({ checkboxData }) => {
  const classes = useStyles();

  return (
    <Box>
      <FormControl component='fieldset' variant='standard'>
        <FormGroup
          row
          sx={{ display: "flex", flexWrap: "nowrap", overflowX: "auto" }}
        >
          {checkboxData?.map((check) => (
            <div key={check.name}>
              <Tooltip
                title={check.name}
                arrow
                placement='top'
                classes={{ tooltip: classes.tooltip }}
              >
                <Checkbox
                  checked={check.value}
                  size='small'
                  sx={{
                    color: check.value ? AppColors.GREY_CHART : "defaultColor",
                    opacity: 0.50,
                    "&.Mui-checked": {
                      color: AppColors.GREY_CHART,
                    },
                  }}
                />
              </Tooltip>
            </div>
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
};

export default CheckboxWithTooltip;
